import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

@Injectable({
  providedIn: 'root'
})
export class SsoApplicationsService {

  constructor(private api: ApiService) {}

  getApplications() {
    return this.api.getRequest(ApiUrl.SSO_APPLICATIONS);
  }

  getApplication(clientId: string) {
    return this.api.getRequest(ApiUrl.SSO_APPLICATION_BY_ID(clientId));
  }

  createApplication(data: {
    name: string;
    description?: string;
    redirectUris: string[];
    postLogoutRedirectUris?: string[];
    allowedRoles: string[];
    scopes?: string[];
  }) {
    return this.api.postRequest(ApiUrl.SSO_APPLICATIONS, data);
  }

  updateApplication(clientId: string, data: {
    name?: string;
    description?: string;
    redirectUris?: string[];
    postLogoutRedirectUris?: string[];
    allowedRoles?: string[];
    scopes?: string[];
  }) {
    return this.api.putRequest(ApiUrl.SSO_APPLICATION_BY_ID(clientId), data);
  }

  rotateSecret(clientId: string) {
    return this.api.putRequest(ApiUrl.SSO_APPLICATION_ROTATE_SECRET(clientId), {});
  }

  revokeApplication(clientId: string) {
    return this.api.putRequest(ApiUrl.SSO_APPLICATION_REVOKE(clientId), {});
  }

  activateApplication(clientId: string) {
    return this.api.putRequest(ApiUrl.SSO_APPLICATION_ACTIVATE(clientId), {});
  }
}
